<template lang="html">
    <b-col sm="12" md="6" lg="6" xl="6" class="text-left">
      <span>{{question.title}} {{question.required ? ' ( * )' : ''}}</span>
      <b-form-input v-model="question.value" :placeholder="question.title" class="mb-3"></b-form-input>
    </b-col>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    prevId: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      question_id: false,
      prev_question_id: false,
      reply: ''
    };
  },
  methods: {

  }
};
</script>

<style lang="css">
  label{
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/surveys/v2/components/Personal.vue